import {component} from "bidello";
import {WebGLRenderer} from "three";
import settings from "./settings";


class Renderer extends component(WebGLRenderer) {
    constructor() {
        super({
            powerPreference: 'high-performance',
            antialiasing: true,
            alpha:true
        });
        this.sortObjects = false;
        this.domElement.style.position = 'absolute';
        this.domElement.style.top = 0;
        this.domElement.setAttribute('id','three-canvas')
        // this.gammaFactor = 2.2;
        // this.gammaInput = true;
        // this.gammaOutput = true;

        this.setClearColor(0x000000,0);
        this.setPixelRatio(settings.dpr);
    }

    onResize({ width, height }) {
        this.setSize(width, height);
    }


}

export default new Renderer();